export * from './carbon-icons-list';
        import * as icons from './carbon-icons-list';
        export default (function () { return Object.keys(icons).map(function (key) { return icons[key]; }); })();


//////////////////
// WEBPACK FOOTER
// ./node_modules/carbon-icons/dist/carbon-icons.es.js
// module id = 11
// module chunks = 15